<div class="row page-title">
  <app-back-button [title]="localizationConstants.ADMIN_BACK_BUTTON_TITLE"></app-back-button>
  <span>{{ localizationConstants.DOCUMENT_FILTERS_PAGE_TITLE | translate }}</span>
</div>

<div *ngIf="options?.famCodes?.length">
  <div class="row">
    <div class="col c-details">
      <mat-card
        appearance="outlined"
        class="document-filter-note-box">
        <mat-card-header class="document-filter-note-header">{{
          localizationConstants.DOCUMENT_FILTERS_NOTE | translate
        }}</mat-card-header>
        <mat-card-content>{{
          localizationConstants.DOCUMENT_FILTERS_NOTE_TEXT | translate
        }}</mat-card-content>
      </mat-card>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="o-grid">
        <div class="o-grid__item col-12 col-md-3 col-sm-5 u-p-bottom-only">
          <label
            class="c-form-label"
            for="role"
            >{{ localizationConstants.DOCUMENT_FILTERS_FAM_CODE | translate }}</label
          >

          <mat-select
            [(ngModel)]="selectedFamCode"
            id="fam"
            name="fam"
            class="c-user-menu__select c-select c-select--lg"
            (ngModelChange)="onFamCodeOrUserRoleChange()"
            required>
            <mat-option
              *ngFor="let fam of options.famCodes"
              [value]="fam">
              {{ fam }}
            </mat-option>
          </mat-select>
        </div>

        <div class="o-grid__item col-12 col-md-4 col-sm-5 u-p-bottom-only">
          <label
            class="c-form-label"
            for="role"
            >{{ localizationConstants.DOCUMENT_FILTERS_USER_ROLE | translate }}</label
          >

          <mat-select
            [(ngModel)]="selectedUserRole"
            id="role"
            name="role"
            class="c-user-menu__select c-select c-select--lg"
            (ngModelChange)="onFamCodeOrUserRoleChange()"
            required>
            <mat-option
              *ngFor="let role of options.roles"
              [value]="role">
              {{ role }}
            </mat-option>
          </mat-select>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <div class="o-grid">
        <div
          class="o-grid__item col-6 col-sm-3 u-p-bottom-only"
          *ngIf="isRoleAndFamSelected()">
          <label
            class="c-form-label"
            for="role"
            >{{ localizationConstants.DOCUMENT_FILTERS_FILE_EXTENSION | translate }}</label
          >

          <mat-select
            [(ngModel)]="selectedFileExtension"
            id="fileExtension"
            name="fileExtension"
            class="c-user-menu__select c-select c-select--lg"
            required>
            <mat-option
              *ngFor="let fileExtension of fileExtensionsForFamCodeAndRole"
              [value]="fileExtension">
              {{ fileExtension }}
            </mat-option>
          </mat-select>
        </div>

        <div
          class="o-grid__item col-6 col-sm-2 u-p-bottom-only align-self-end"
          *ngIf="isRoleAndFamSelected()">
          <button
            (click)="onNewDocumentFilterAdd(selectedFileExtension)"
            type="button"
            class="button button-primary button-block document-filter-btn-add">
            {{ localizationConstants.BUTTON_ADD | translate }}
          </button>
        </div>

        <div class="col-sm-1"></div>

        <div
          class="o-grid__item col-6 col-sm-4 u-p-bottom-only"
          *ngIf="isRoleAndFamSelected()">
          <label
            class="c-form-label"
            for="role"
            >{{ localizationConstants.DOCUMENT_FILTERS_DOCUMENT_PREFIX | translate }}</label
          >

          <input
            [(ngModel)]="selectedFilePrefix"
            name="documentPrefix"
            type="text"
            placeholder="{{
              localizationConstants.DOCUMENT_FILTERS_DOCUMENT_PREFIX_ADD_PLACEHOLDER | translate
            }}"
            class="c-input c-input--gamma document-filter-file-prefix-input" />
        </div>

        <div
          class="o-grid__item col-6 col-sm-2 u-p-bottom-only align-self-end"
          *ngIf="isRoleAndFamSelected()">
          <button
            (click)="onNewDocumentFilterAdd(selectedFilePrefix); selectedFilePrefix = null"
            type="button"
            class="button button-primary button-block document-filter-btn-add">
            {{ localizationConstants.BUTTON_ADD | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div [hidden]="!isRoleAndFamSelected()">
  <div class="row wrap">
    <div class="col col-md-6">
      <form class="c-search-form--full">
        <div class="c-input-group">
          <input
            type="text"
            name="search"
            id="input-search"
            [(ngModel)]="dataSource.filter"
            class="c-input c-input--beta"
            placeholder="{{ localizationConstants.QUICK_GRID_FILTER_SEARCH | translate }}"
            required />
          <input
            *ngIf="dataSource.filter"
            id="filters-search-clear"
            (click)="dataSource.filter = ''"
            class="c-button c-button--search c-close-search c-button--search--sm"
            value="Clear" />
          <input
            *ngIf="!dataSource.filter"
            id="filters-search"
            type="submit"
            class="c-button c-button--search c-button--search--sm"
            value="Search" />
        </div>
      </form>
    </div>
  </div>
  <div class="row">
    <div class="col col-md-6">
      <div class="u-scroll--horizontal">
        <div class="col">
          <table
            mat-table
            [dataSource]="dataSource"
            matSort
            class="c-table">
            <ng-container matColumnDef="filterValue">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="c-table__column-title"
                width="70%">
                {{
                  localizationConstants.DOCUMENT_FILTERS_EXISTING_FILTERS_COLUMN_NAME | translate
                }}
              </th>
              <td
                mat-cell
                *matCellDef="let filter">
                {{ filter.filterValue }}
              </td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="c-table__column-title"
                width="30%"></th>
              <td
                mat-cell
                *matCellDef="let filter">
                <button
                  type="button"
                  class="button--sm button-secondary button-block"
                  (click)="onDocumentFilterDelete(filter)">
                  <span>{{ localizationConstants.BUTTON_DELETE | translate }}</span>
                </button>
              </td>
            </ng-container>

            <tr
              matNoDataRow
              *matNoDataRow>
              <td colspan="12">
                <div class="center">
                  {{ localizationConstants.TABLE_NO_RESULTS | translate }}
                </div>
              </td>
            </tr>

            <tr
              mat-header-row
              *matHeaderRowDef="['filterValue', 'actions']"></tr>
            <tr
              mat-row
              *matRowDef="let filter; columns: ['filterValue', 'actions']"
              class="c-table__row"></tr>
          </table>
        </div>
      </div>
      <div class="c-pagination--desktop">
        <div class="col-12">
          <mat-paginator
            [showFirstLastButtons]="true"
            [pageSize]="pageSize"
            [pageSizeOptions]="[10, 50, 100]"></mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
